<template lang="pug">
.flex.items-end.text-center.text-shadow.text-2xs.text-title-text.font-bold.leading-none
  div
    i18n-t.inline(:keypath="te(`policy.privacy_link.${resourceId}`) ? `policy.privacy_link.${resourceId}` : `description.privacy_link`", tag="div", scope="global")
      template(#name)
        span.site-name {{ siteName }}
      template(#terms)
        button.privacy-link.ms-1(type="button", @click="handleShowPrivacy('privacy-policy')") {{ t('common.terms_of_service') }}
      template(#disclaimer)
        button.privacy-link.ms-1(type="button", @click="handleShowPrivacy('disclaimer')") {{ t('policy.disclaimer') }}
      template(#policy)
        button.privacy-link.ms-1(type="button", @click="handleShowPrivacy('privacy-policy')") {{ t('policy.privacy_policy') }}
      template(#aml_policy)
        button.privacy-link.ms-1(type="button", @click="handleShowPrivacy('aml-kyc-policy')") {{ t('policy.aml_kyc_policy') }}
      template(v-if="customizeResource", #responsible_gambling)
        button.privacy-link.ms-1(type="button", @click="handleShowPrivacy('responsible-gambling')") {{ t('policy.responsible_gambling') }}
      template(#conditions)
        button.privacy-link.ms-1(type="button", @click="handleShowPrivacy('terms-and-conditions')") {{ t('policy.conditions') }}
      template(v-if="customizeResource", #terms_and_conditions)
        button.privacy-link.ms-1(type="button", @click="handleShowPrivacy('terms-and-conditions')") {{ t('common.terms_and_conditions') }}
      template(v-if="customizeResource", #kyc_policy)
        button.privacy-link.ms-1(type="button", @click="handleShowPrivacy('kyc-policy')") {{ t('common.kyc_policy') }}
      template(v-if="customizeResource", #underage_gaming_policy)
        button.privacy-link.ms-1(type="button", @click="handleShowPrivacy('underage-gaming-policy')") {{ t('common.underage_gaming_policy') }}
      template(v-if="customizeResource", #self_exclusion_policy)
        button.privacy-link.ms-1(type="button", @click="handleShowPrivacy('self-exclusion-policy')") {{ t('common.self_exclusion_policy') }}
    Version.inline.ms-4
</template>

<script setup>
import { useI18n } from '#imports'

const props = defineProps({
  resourceId: {
    type: String,
    required: true,
  },
  customizeResource: {
    type: Boolean,
    default: false,
  },
  siteName: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['showPrivacy'])

const { t, te } = useI18n()

const handleShowPrivacy = (policyName) => {
  emit('showPrivacy', policyName)
}
</script>

<style lang="scss" scoped>
.privacy-link {
  color: #609eff;
  text-decoration: underline;
}
</style>
